export const mainLayoutStyles = {
  p: 2,
  pt: 0,
  flexGrow: {
    xs: 0,
    md: 1,
  },
  width: '100%',
  height: '100%',
  overflow: 'auto',
};
